import { defaultScenario } from './scenarios';
import type { EventData } from './types';

// Empty template for a new event. Names suggest typical structure but all
// numeric values start at zero — the user fills them in.
export function emptyEventData(): EventData {
  return {
    tickets: [
      { id: 'early', name: 'Early Bird', qty: 0, priceMin: 0, priceMax: 0 },
      { id: 'standard', name: 'Standard', qty: 0, priceMin: 0, priceMax: 0 },
      { id: 'vip', name: 'VIP', qty: 0, priceMin: 0, priceMax: 0 },
    ],
    sponsors: [
      { id: 'tier1', name: 'Bronze', qty: 0, priceMin: 0, priceMax: 0 },
      { id: 'tier2', name: 'Silver', qty: 0, priceMin: 0, priceMax: 0 },
      { id: 'tier3', name: 'Gold', qty: 0, priceMin: 0, priceMax: 0 },
      { id: 'tier4', name: 'Platinum', qty: 0, priceMin: 0, priceMax: 0 },
    ],
    addons: [
      {
        id: 'stage',
        name: 'Stage Sponsor',
        enabled: false,
        price: 0,
        multiplier: 1,
        multiplierLabel: 'tracks',
      },
      { id: 'vip_dinner', name: 'VIP Dinner', enabled: false, price: 0 },
      { id: 'lunch', name: 'Lunch Sponsor', enabled: false, price: 0 },
      { id: 'coffee', name: 'Coffee Zone', enabled: false, price: 0 },
      { id: 'afterparty', name: 'Afterparty', enabled: false, price: 0 },
      { id: 'lanyard', name: 'Lanyard', enabled: false, price: 0 },
      { id: 'badge', name: 'Badge', enabled: false, price: 0 },
      { id: 'charging', name: 'Charging Zone', enabled: false, price: 0 },
    ],
    costs: {
      // Conference categories
      venue: [],
      catering: [],
      security: [],
      av: [],
      marketing: [],
      additional: [],
      // Meetup categories
      refreshments: [],
      food: [],
      swags: [],
      materials: [],
      speakers: [],
    },
    scenario: defaultScenario(),
    cashflowPlans: {},
    vatMode: 'net',
    vatRate: 0.23,
  };
}

export function newId(prefix = 'i'): string {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}

// Meetup template starts much leaner: one ticket tier (Standard), one
// sponsor slot, no add-ons. Cost categories still initialise to []
// across both templates so the UI can switch type without losing data.
export function emptyMeetupEventData(): EventData {
  const base = emptyEventData();
  return {
    ...base,
    tickets: [
      { id: 'standard', name: 'Standard', qty: 0, priceMin: 0, priceMax: 0 },
    ],
    sponsors: [
      { id: newId('s'), name: 'Sponsor 1', qty: 1, priceMin: 0, priceMax: 0 },
    ],
    addons: [],
  };
}
